import React from 'react';

import { Grid } from '@mui/material';

import SwitchItem from './SwitchItem';
import { Switch } from 'types';

interface Props {
  handleInstrumentSelected: (instrumentId: number) => void;
  openConnectDialog: () => void;
  switches: Switch[] | undefined;
  selectedInstrumentId: number;
}

const SwitchDisplay = ({
  handleInstrumentSelected,
  openConnectDialog,
  switches,
  selectedInstrumentId,
}: Props) => {
  const instrumentSelected = (instrumentId: number) => {
    handleInstrumentSelected(instrumentId);
  };

  const handleDoubleClick = (instrumentId: number) => {
    handleInstrumentSelected(instrumentId);
    openConnectDialog();
  };

  return (
    <Grid container>
      {switches?.map((switchItem: Switch) => (
        <React.Fragment key={switchItem.id}>
          <Grid item style={{ maxWidth: '8rem' }}>
            <SwitchItem
              switchItem={switchItem}
              onClick={() => instrumentSelected(switchItem.id)}
              onDoubleClick={() => handleDoubleClick(switchItem.id)}
              selected={switchItem.id === selectedInstrumentId}
            />
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default SwitchDisplay;
